import React, { ReactElement } from "react";
import "./Unauthorized.scss";

export default function Unauthorized(): ReactElement {
    return (
        <div className="error-400">
            <h1>Not authorized</h1>
            <img alt="400 error" src="/400.svg" />
        </div>
    );
}
